export default "__VITE_ASSET__ClYX6qfN__"